module.exports = __webpack_public_path__ + "static/media/LogoERTurismo-it.9c0fc630.png";